namespace Ir.Components.Workbook.Widgets.ReportWidget {
    interface IViewModel {
        config: WorkbookConfig;
        dispose: Function;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;

        let reportWidget: ReportWidget = params.widget;
        reportWidget.set$ReportContent(componentInfo.element);
        reportWidget.setup();

        //this.dispose = ResizeService.createResizeObserverForComponent(componentInfo.element, function () { reportWidget.repaint(); }, true);
    }
}